import { Component, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { DfsService } from '../../services/dfs.service';
import { Event as DfsEvent, NextEvent } from '../../models/dfs-events.models';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { SavingsCalculatorDialogComponent } from '../../components/savings-calculator/savings-calculator.component';
import { MatButtonModule } from '@angular/material/button';
import { EventConsentStatus } from '../../constants/dfs.enums';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'app-event-details',
  standalone: true,
  imports: [
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatButtonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    CommonModule
  ],
  templateUrl: './event-details.component.html',
  styleUrl: './event-details.component.scss'
})
export class EventDetailsComponent {
  tpi: boolean = false;
  eventStatus = EventConsentStatus;
  displayedColumns: string[] = [
    'EventDate',
    'EventFromTime',
    'EventEndTime',
    'MeterNo',
    'Expected',
    'Actual',
    'Savings',
    'Earnings',
    'ReductionPercent',
    'Status'
  ];
  dataSource: MatTableDataSource<DfsEvent> = new MatTableDataSource<DfsEvent>();
  nextEvent: NextEvent | null = null;


  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort; // Optional: For sorting

  constructor(private dfsService: DfsService, private dialog: MatDialog, private util: UtilService) { }

  ngOnInit(): void {
    this.dfsService.isTpi.subscribe(isTpi => {
      this.tpi = isTpi;
    });
    this.fetchEvents();
    this.fetchEventSummary();
  }

  ngAfterViewChecked(): void {
    if (!this.dataSource.paginator && this.paginator) {
      this.dataSource.paginator = this.paginator;
    }
    if (!this.dataSource.sort && this.sort) {
      this.dataSource.sort = this.sort; // Optional: For sorting
    }
  }

  fetchEventSummary(): void {
    this.dfsService.getEventSummary().subscribe((data) => {
      this.nextEvent = data.nextEvent;
      // this.nextEvent.date = new Date(this.nextEvent.date).toDateString();
      // this.nextEvent.time = new Date(this.nextEvent.time).toLocaleTimeString();
      // this.nextEvent.expectedUsage = 54.5;
      // this.nextEvent.earningsPerKW = 0.15;
      if (this.nextEvent.earningsPerKW && this.nextEvent.expectedUsage) {
        this.nextEvent.maxSavings = parseFloat((this.nextEvent.earningsPerKW * this.nextEvent.expectedUsage).toFixed(2));
      } else {
        this.nextEvent.maxSavings = 0;
      }
    });
  }

  fetchEvents(): void {
    this.dfsService.getEvents().subscribe({
      next: (response) => {
        this.dataSource.data = response.data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort; // Optional: For sorting
      },
      error: (error) => {
        console.error('Error fetching events:', error);
      }
    });
  }
  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    // Reset to the first page if the filter changes
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openSavingsCalculator(nextEvent: NextEvent): void {
    this.dialog.open(SavingsCalculatorDialogComponent, {
      // width: '400px',
      data: { nextEvent }
    });
  }

  manageOpting (nextEvent: NextEvent, consent: boolean): void {
    this.dfsService.manageOptingForEvent(nextEvent, consent).subscribe({
      next: () => this.fetchEventSummary(),
      error: (error) => this.util.openSnackBar('An error occurred. Please try again later.', 'Close', 'error')
    });
  }
}
